import React from 'react'
import Title from '../../../Common/Title'
import bg from "../../../../Assets/Images/map-platform.png"
import img from "../../../../Assets/Images/_e-img-platform-stats.448717bff4353eedd785_cn.png"
import item1 from "../../../../Assets/Images/ic-platform-stats-01@3x.png"
import item2 from "../../../../Assets/Images/ic-platform-stats-02@3x.png"
import item3 from "../../../../Assets/Images/ic-platform-stats-03@3x.png"
import "./styles.scss"

function PlatformMap() {
  return (
    <div className='platformMap'>
        
        <div className="platformMap-bg">
            <img src={bg} alt="" />
        </div>

        <div className="platformMap-container">
        <Title title={<>{`统计功能`}</>} />
        <div className="map">
            <img src={img} alt="" />
        </div>
        <div className="map-list">
          {dataMap.map((item,index) => (
            <div className="item" key={index}>
              <div className="img">
                <img src={item.img} alt="" />
              </div>
              <div className="content2">
                <div className="title">{item.title}</div>
                <div className="detail">{item.detail}</div>
              </div>
            </div>
          ))}
        </div>
        </div>
    </div>
  )
}

export default PlatformMap

const dataMap = [
    {
      img: item1,
      title: '统计数据一目了然',
      detail: '用图表确认全部统计'
    },
    {
      img: item2,
      title: 'Excel文件单独收藏',
      detail: '下载统计数据至Excel'
    },
    {
      img: item3,
      title: '提供多种统计数据',
      detail: '按工作/类别/咨询员/评分/评论分类等'
    },
]